import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type UserEngagementHistory = Readonly<{
  id: number;
  user_id: number;
  organization_name?: string;
  city?: string;
  state?: string;
  role?: string;
  start_date?: string;
  end_date?: string;
  achievements?: string;
}>;

export type UserEngagementHistoryRequest = Omit<
  UserEngagementHistory,
  'id' | 'user_id' | 'created_at' | 'updated_at'
>;

export const userEngagementHistoryApi = createApi({
  reducerPath: 'userEngagementHistoryApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getUserEngagementHistory: builder.query<UserEngagementHistory[], undefined>({
      query: () => ({
        url: '/user-engagement-history',
        method: 'GET',
      }),
    }),

    getEngagementHistoryById: builder.query<UserEngagementHistory, number>({
      query: (id) => ({
        url: `/user-engagement-history/${id}`,
        method: 'GET',
      }),
    }),

    createEngagementHistory: builder.mutation<UserEngagementHistory, UserEngagementHistoryRequest>({
      query: (engagementHistoryData) => {
        return {
          url: '/user-engagement-history',
          method: 'POST',
          body: {
            ...engagementHistoryData,
          },
        };
      },
    }),

    updateEngagementHistory: builder.mutation<
      UserEngagementHistory,
      { id: number; data: UserEngagementHistoryRequest }
    >({
      query: ({ id, data }) => {
        return {
          url: `/user-engagement-history/${id}`,
          method: 'PUT',
          body: {
            ...data,
          },
        };
      },
    }),

    deleteEngagementHistory: builder.mutation<undefined, number>({
      query: (id) => ({
        url: `/user-engagement-history/${id}`,
        method: 'DELETE',
      }),
    }),

    deleteAllEngagementHistory: builder.mutation<{ message: string }, undefined>({
      query: () => ({
        url: '/user-engagement-history',
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetUserEngagementHistoryQuery,
  useGetEngagementHistoryByIdQuery,
  useCreateEngagementHistoryMutation,
  useUpdateEngagementHistoryMutation,
  useDeleteEngagementHistoryMutation,
  useDeleteAllEngagementHistoryMutation,
} = userEngagementHistoryApi;
